<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <ng-icon name="heroMagnifyingGlassCircle"></ng-icon>
    <div>
      <h2>All Contract Search Report
      </h2>
    </div>
  </div>
</div>
<div class="inner-box">
  <!-- <mat-card class="hide-stepper" class="without-expansion">
        <mat-card-content class="form-head"> -->
  <!-- <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
              <div class="col-md-12 p-0 flex-wrap d-flex">
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Select Contract Types</mat-label>
                      <input type="text" matInput [matAutocomplete]="auto" formControlName="contractTypeName"
                             (input)="onInputChange($event.target.value)" #contractInput [errorStateMatcher]="matcher">
                             <mat-chip-listbox>
                              <mat-chip *ngFor="let value of selectedValues" [removable]="true" (removed)="removeValue(value)">
                                {{ value.name }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                              </mat-chip>
                            </mat-chip-listbox>
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                        <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
            
                      <mat-error *ngIf="searchForm.get('contractTypeName').hasError('required')">
                        Contract Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                 
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Contract Status</mat-label>
                      <mat-select formControlName="contractStatus" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let contract of contractStatus" [value]="contract.id">{{contract.name
                          }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Transaction Type</mat-label>
                      <mat-select formControlName="transactionTypeId" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let trans of transactions" [value]="trans.id">{{ trans.name
                          }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('transactionTypeId')?.hasError('required')">
                        Transaction Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Obligation Type</mat-label>
                      <mat-select formControlName="entitlementTypeId" [errorStateMatcher]="matcher" multiple>
                        <mat-option *ngFor="let obligation of obligationTypes" [value]="obligation.id">{{
                          obligation.name
                          }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('entitlementTypeId')?.hasError('required')">
                        Obligation Type is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Obligation Status</mat-label>
                      <input type="text" matInput autocomplete="off" formControlName="obligationStatus"
                        [errorStateMatcher]="matcher">
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Actions</mat-label>
                      <mat-select formControlName="action"  multiple>
                        <mat-option *ngFor="let option of actionType" [value]="option">{{ option }}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="searchForm.get('action').hasError('required')">
                        Number Of Employee is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Users</mat-label>
                      <mat-select formControlName="users" [errorStateMatcher]="matcher"  multiple>
                        <mat-option *ngFor="let user of allUsers" [value]="user.id">{{ user.firstName +" "+ user.lastName
                          }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dense-2">
                    <mat-form-field appearance="outline">
                      <mat-label>Meta Data</mat-label>
                      <mat-select formControlName="metaData">
                        <mat-option *ngFor="let meta of metaData" [value]="meta">{{ meta }}</mat-option>
                    </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                  <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Enter a date range</mat-label>
                          <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start date" formControlName="startDate"[errorStateMatcher]="matcher">
                            <input matEndDate placeholder="End date" formControlName="endDate"[errorStateMatcher]="matcher">
                          </mat-date-range-input>
                          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker></mat-date-range-picker>
                          <mat-error *ngIf="searchForm.get('startDate').hasError('required')">
                            Select Start Date
                          </mat-error>
                          <mat-error
                            *ngIf="searchForm.get('startDate').invalid && !searchForm.get('startDate').hasError('required')">
                            Start Date is invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  <div class="col-md-4">
                    <div class="dense-2">

                      <div class="d-flex col-md-12 justify-content-end p-0">
                        <button color="primary  " class="outlined-btn" mat-raised-button (click)="reset()" type="reset"
                        [disabled]="isLoading">Reset</button>
                        
                       <button mat-raised-button  class="ml-3" color="accent" >Search</button> 
                       <button color="accent" mat-raised-button class="ml-3" type="submit" [disabled]="searchForm.invalid">Save</button>
                      </div>  
                      
                    </div>
                  </div> 
              </div>
              
      </form> -->
  <!-- <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <form [formGroup]="notificationForm">
        <div class="col-md-3">
          <div class="dense-2">
            <mat-form-field appearance="outline">
              <mat-label>Select Contract Type</mat-label>
              <input type="text" matInput [matAutocomplete]="auto" formControlName="contractTypeName"
                (input)="onInputChange($event.target.value)" #contractInput [errorStateMatcher]="matcher">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onContractTypeSelect($event)">
                <mat-option disabled *ngIf="isNotFound">No Items Found</mat-option>
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="notificationForm.get('contractTypeName').hasError('required')">
                Contract Type is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-1 p-0">
      <button color="accent" mat-raised-button (click)="openSaveKpi()">
        Save KPI
      </button>
    </div>
  </div> -->
  <div class="col-md-12 common-table-style p-0">

    <p-table #dt [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [alwaysShowPaginator]="false"
      [columns]="selectedAllContract" [value]="contractList" [tableStyle]="{'min-width': '50rem'}"
      [globalFilterFields]="selectedColumns"
      [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [resizableColumns]="true" [reorderableColumns]="true" styleClass="p-datatable-sm"
      [ngClass]="{'scrollable-table': tableScrollable}">
      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-between align-items-center flex-direction-row p-0">
         
          <button pButton label="Clear" class="p-button-outlined pi pi-filter-slash" (click)="clear(dt)"></button>
          <div class="p-input-icon-left ml-2 search-container">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="Search" class="search-input" />
            </div>
           
            <div class="d-flex align-items-center justify-content-between action-buttons">  
            <p-multiSelect class="ml-2" [options]="allColumnsWithAttributes" [(ngModel)]="selectedAllContract"
              optionLabel="header" selectedItemsLabel="{0} columns selected" [style]="{'min-width': '200px'}"
              placeholder="Choose Columns" (onChange)="onColumnSelect()"></p-multiSelect>
                <i (click)="exporContractsList()" class="ml-2 pi pi-file-excel export-icon"
                style="font-size: 1.5rem; color: green"></i>
              </div>
                
            <button color="accent" mat-raised-button (click)="openSaveKpi()" class="mx-2 kpi-button">
              Save KPI
            </button>
          </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="dataTable">
            <div>
              {{col.header}}
              <ng-container
                *ngIf="col.field !== 'createdDate' && col.field !== 'updateDate' && !col.field.startsWith('attr_'); else dateOrAttrFilter">
                <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
              </ng-container>
              <ng-template #dateOrAttrFilter>
                <ng-container
                  *ngIf="col.field === 'createdDate' || col.field === 'updateDate' || isDateAttribute(col.field); else textFilter">
                  <p-columnFilter type="date" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                </ng-container>
                <ng-template #textFilter>
                  <p-columnFilter type="text" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                </ng-template>
              </ng-template>
              <ng-template #filterIcon>
                <i class="pi pi-filter" style="cursor: pointer;" (click)="showFilterInput(col.field)"></i>
              </ng-template>
            </div>
            <input *ngIf="showInput === col.field" pInputText type="text" [(ngModel)]="filters[col.field]"
              (input)="applyFilters()" class="form-control" placeholder="Search {{col.header}}" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 !== 0}">
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field === 'contractName'">
              <a [routerLink]="['/app/contract', 'view', product.id]">{{product[col.field]}}</a>
            </td>
            <td *ngIf="col.field === 'createdDate'">
              {{product._createdDateFormatted}}
            </td>
            <td *ngIf="col.field === 'updateDate'">
              {{product._updateDateFormatted}}
            </td>
            <td *ngIf="col.field.startsWith('attr_')">
              {{product[col.field + '_formatted'] || product[col.field] || (product.attributes &&
              product.attributes[col.header])}}
            </td>
            <td
              *ngIf="col.field !== 'contractName' && col.field !== 'createdDate' && col.field !== 'updateDate' && !col.field.startsWith('attr_')">
              {{product[col.field]}}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">No contractLists found.</td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
<!--  
    </mat-card-content>
    </mat-card> -->